import { API_URLs } from "../../constants/api_urls";
import { MembershipCheckoutData, MembershipData, PricingData, SubscriptionFrequencies } from "../../types/membership/membershipTypes";
import axiosClient from "../../utils/axiosClient";

export const fetchMembership = async (): Promise<MembershipData> => {
    const response = await axiosClient.get(API_URLs.MEMBERSHIP);
    return response.data as MembershipData;
}

export const fetchPricing = async (): Promise<PricingData> => {
    const response = await axiosClient.get(API_URLs.PRICING);
    return response.data;
}

export const fetchPublicPricing = async (): Promise<PricingData> => {
    const response = await axiosClient.get(API_URLs.PRICING_PUBLIC);
    return response.data;
}

export const startMembership = async (frequency_slug: SubscriptionFrequencies, plan_id: number): Promise<MembershipCheckoutData> => {
    const response = await axiosClient.post(API_URLs.MEMBERSHIP, { frequency_slug, plan_id });
    return response.data;
}

export const changeMembership = async (frequency_slug: SubscriptionFrequencies,
    plan_id: number,
    active_plan_uuid: string
): Promise<MembershipCheckoutData> => {
    const response = await axiosClient.put(API_URLs.CHANGE_MEMBERSHIP.replace('<activePlanUUID>', active_plan_uuid), { frequency_slug, plan_id })
    return response.data;
}

export const verifyMembershipPayment = async (paymentUUID: string, razorpay_payment_id: string, razorpay_signature: string) : Promise<boolean> => {
    const response = await axiosClient.post(API_URLs.VERIFY_MEMBERSHIP_PAYMENT.replace('<paymentUUID>', paymentUUID), {razorpay_payment_id, razorpay_signature});
    return response.data.status;
}

export const verifyAppleMembershipReceipt = async (paymentUUID: string, app_store_receipt: string) : Promise<boolean> => {
    const response = await axiosClient.post(API_URLs.VERIFY_APPLE_PAYMENT_CB.replace('<paymentUUID>', paymentUUID), {app_store_receipt});
    return response.data.status;
}